'use strict';

import angular from 'angular';

import restModalDirective from 'incidents/components/buttons/rest-modal';

import versioner from '../versioner';
import process from './process';


const VERSION_NAME = 'jcw_after_hours';

versioner[VERSION_NAME] = {
	process: process,
}

const MODULE_NAME = `daupler.incidents.versions.${VERSION_NAME}`;

var app = angular.module(MODULE_NAME, []);

export default MODULE_NAME;
